<template>
  <v-container>
    <v-overlay :value="isLoading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-card-text>
        <TimeseriesFilters
          :concepts="concepts"
          :kitchens="kitchens"
          v-on:searchTimeseries="getStats"
        />
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-text>
        <v-overlay
          :absolute="true"
          :value="!currentStats.labels.length"
          :opacity="0.7"
        >
          <v-btn rounded disabled>
            <span>No data</span>
          </v-btn>
        </v-overlay>
        <line-chart
          :chart-data="currentStats"
          :options="chartOptions"
        ></line-chart>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <v-row>
          <v-col>
            <v-switch v-model="staffSwitch" label="Staff"></v-switch>
          </v-col>
          <v-col>
            <v-text-field
              class="mx-3"
              v-model="staffCapacity"
              type="number"
              label="Staff capacity in one hour"
              @click:append-outer="increment"
              @click:prepend="decrement"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="mt-3">
        <TimeseriesTable
          :data="data"
          :staffSwitch="staffSwitch"
          :staffCapacity="staffCapacity"
          :interval="interval"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import colors from "vuetify/lib/util/colors";
import { mapState, mapActions } from "vuex";
import LineChart from "@/LineChart.js";
import TimeseriesFilters from "@/components/Analyze/TimeseriesFilters.vue";
import TimeseriesTable from "@/components/Analyze/TimeseriesTable.vue";

export default {
  components: { LineChart, TimeseriesFilters, TimeseriesTable },
  data: function () {
    return {
      staffSwitch: false,
      staffCapacity: "1",
      interval: 1,
      data: {},
      chartOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    ...mapState({
      kitchens: (state) => state.restaurant.kitchens,
      concepts: (state) => state.restaurant.concepts,
      kitchensLoading: (state) => state.restaurant.fetchAllKitchens.pending,
      conceptsLoading: (state) => state.restaurant.fetchAllConcepts.pending,
      timeseriesLoading: (state) => state.orders.fetchTimeseries.pending,
    }),
    currentStats() {
      if (this.data) {
        if (this.data["yAxis"]) {
          let datasets = [];
          for (let [key, value] of Object.entries(this.data["yAxis"])) {
            datasets.push({
              label: this.getWeekdayName(key),
              data: value,
              backgroundColor: this.getColor(key),
            });
          }
          return {
            labels: this.data["xAxis"],
            datasets: datasets,
          };
        }
      }
      return {
        labels: [],
        datasets: [],
      };
    },
    isLoading() {
      return (
        this.kitchensLoading || this.conceptsLoading || this.timeseriesLoading
      );
    },
  },
  methods: {
    ...mapActions({
      setError: "setError",
    }),
    ...mapActions("restaurant", {
      fetchAllConcepts: "fetchAllConcepts",
      fetchAllKitchens: "fetchAllKitchens",
    }),
    ...mapActions("orders", {
      fetchTimeseries: "fetchTimeseries",
    }),
    getStats(payload) {
      this.interval = this.convertStringToMinutes(payload.interval);
      let params = {
        kitchenUuid: payload.kitchenUuid,
        locationUuid: payload.locationUuid,
        conceptUuid: payload.conceptUuid,
        startDate: payload.startDate,
        endDate: payload.endDate,
        startMinute: this.convertStringToMinutes(payload.startMinute),
        endMinute: this.convertStringToMinutes(payload.endMinute),
        interval: this.interval,
      };

      return this.fetchTimeseries(params)
        .then((data) => {
          this.data = data;
        })
        .catch((error) => {
          this.setError(error);
        });
    },
    convertStringToMinutes(string) {
      if (string && string.split(":").length) {
        let hours = string.split(":")[0];
        let minutes = string.split(":")[1];
        return parseInt(hours) * 60 + parseInt(minutes);
      }
      return 1440;
    },
    getColor(day) {
      let chartColors = {
        0: colors.red.lighten3,
        1: colors.deepOrange.lighten3,
        2: colors.yellow.lighten3,
        3: colors.blueGrey.lighten3,
        4: colors.blue.lighten3,
        5: colors.purple.lighten3,
        6: colors.green.lighten3,
      };
      return chartColors[day];
    },
    getWeekdayName(weekday) {
      let sorted = {
        0: "Monday",
        1: "Tuesday",
        2: "Wednesday",
        3: "Thursday",
        4: "Friday",
        5: "Saturday",
        6: "Sunday",
      };
      return sorted[weekday];
    },
    increment() {
      this.staffCapacity = parseInt(this.staffCapacity, 10) + 1;
    },
    decrement() {
      this.staffCapacity = parseInt(this.staffCapacity, 10) - 1;
    },
  },
  created() {
    this.fetchAllConcepts().catch((error) => {
      this.setError(error);
    });
    this.fetchAllKitchens().catch((error) => {
      this.setError(error);
    });
  },
};
</script>
